import React from "react";

import {CircularProgress, Stack} from "@mui/joy";

// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonStepper from "../Common/CommonStepper";
import {setArrayKey, splitToList} from "../../utils/misc";


class LetterCreateInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            data: {},
            lockedSteps: [],
        }
        this.steps = [
            {
                order: 0,
                title: 'Получатель',
            },
            {
                order: 1,
                title: 'Данные',
            },
        ]
    }

    async retrieveFields() {
        const api = new BaseApi();
        let url = 'letter/create_form/';
        let params = {
            fields: JSON.stringify(
                [
                    'incoming_number',
                    'incoming_date',
                    'number',
                    'title',
                    'welcome_text',
                    'about_company',
                    'letter_wordings',
                    'businesses',
                    'accounts',
                    'tasks',
                    'free_text',
                    'signature',
                ]
            )
        }
        let response = await api.get(
            url,
            params
        );
        let formFields = response.data
        url = `account/customers/`;
        response = await api.get(
            url,
            {
                page_size: 10000,
            }
        );
        formFields = setArrayKey(
            formFields,
            'name',
            'accounts',
            'options',
            response.data.results.map((each) => (
                {'value': each.id, 'label': each.nameshort}
            ))
        )
        url = `subscriber/`;
        response = await api.get(
            url,
            {
                active: true,
                can_sign_letters: true,
                page_size: 10000,
            }
        );
        formFields = setArrayKey(
            formFields,
            'name',
            'signature',
            'options',
            response.data.results.map((each) => (
                {'value': each.id, 'label': `${each.user.first_name} ${each.user.last_name}`}
            ))
        )
        formFields = setArrayKey(
            formFields,
            'name',
            'submitButton',
            'label',
            'Далее',
        )
        return formFields
    }

    async componentDidMount() {
        const api = new BaseApi();
        const url = `contact/`;
        const params = {
            entity: 'Account',
            entity_id: this.props.account?.id,

            opportunity: this.props.opportunity?.id,
            page_size: 10000,
        }
        let response = await api.get(
            url,
            params
        );
        let formFields = [
            {
                name: 'contact',
                label: 'Получатель',
                xs: 12,
                sm: null,
                md: null,
                lg: null,
                xl: null,
                required: true,
                default: this.props.contact?this.props.contact.id:response.data.results[0]?response.data.results[0].id:null,
                type: 'select',
                options: response.data.results.map(
                    (c) => ({
                        value: c.id,
                        label: `${c.first_name} ${c.last_name} - ${c.role}`,
                    })
                )
            },
            {
                type: 'submit',
                label: 'Далее',
            },
        ]
        this.setState(
            {
                formFields: formFields,
            }
        );

    }

    async processStep0(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        let formFields = await this.retrieveFields()
        this.setState(
            {
                data: formDataObj,
                activeStep: 1,
                formFields: formFields,
            },
        )
    }

    async processStep1(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        let data = {...this.state.data, ...formDataObj};
        data.opportunity = this.props.opportunity?.id;
        data.account = this.props.account?.id;
        data.lead = this.props.lead?.id;
        if ('letter_wordings' in data) {
            data.letter_wordings = splitToList(data.letter_wordings, ',')
        }
        if ('businesses' in data) {
            data.businesses = splitToList(data.businesses, ',')
        }
        if ('accounts' in data) {
            data.accounts = splitToList(data.accounts, ',')
        }
        if ('tasks' in data) {
            data.tasks = splitToList(data.tasks, ',')
        }
        let url = `letter/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            data
        );
        if (response.status === 201) {
            await this.props.callBack();
        }
    }

    async setStep(order) {
        let formData = new FormData();
        let formFake = {'state': {'formData': formData}}
        if (order === 0){
            await this.componentDidMount()
        }
        else {
            await this['processStep'+(order-1)](formFake)
        }
        this.setState(
            {activeStep: order}
        )
    }

    render() {
        if (!this.state.formFields) {
            return (<CircularProgress />)
        }
        if (this.state.activeStep === 0) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                        lockedSteps={this.state.lockedSteps}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep0.bind(this)}
                    />
                </>
            )
        }
        else if (this.state.activeStep === 1) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                        lockedSteps={this.state.lockedSteps}
                    />
                    <Stack>
                        <CommonForm
                            fields={this.state.formFields}
                            processForm={this.processStep1.bind(this)}
                        />
                    </Stack>
                </>
            )
        }
    }
}

export default LetterCreateInner
